var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#222","strokeWidth":"2","fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.5 15.732L15.732 8.5 8.5 1.268","key":0}),React.createElement("path",{"d":"M1.169 8.414h12.785","strokeLinecap":"square","key":1})]));
}

ArrowRight.defaultProps = {"width":"18","height":"17"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
